//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Fuse from 'fuse.js';
import { debounce, convertToTranslit } from '@razlet/utils';
import getCargoSender from '~/api/senders/cargo-sender';
import { autocompleteManager } from '~/services/autocomplete-manager';

export default {
  name: 'base-autocomplete',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, Array, String],
      default: null,
    },
    params: {
      type: Object,
      default: () => {},
    },
    valuesParams: {
      type: Object,
      default: () => {},
    },
    searchKeys: {
      type: Array,
      default: () => ([]),
    },
    shouldSortSearch: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default: '',
    },
    path: {
      type: String,
      required: true,
    },
    idProperty: {
      type: String,
      default: 'codeEn',
    },
    labelProperty: {
      type: String,
      default: 'name',
    },
    disabledProperty: {
      type: String,
      default: 'disabled',
    },
    big: {
      type: Boolean,
      default: true,
    },
    inputAsIs: {
      type: Boolean,
      default: false,
    },
    isFlat: {
      type: Boolean,
      default: false,
    },
    isError: Boolean,
    required: Boolean,
    multiple: Boolean,
    disabled: Boolean,
    long: Boolean,
    filterFunc: {
      type: Function,
      default: null,
    },
    mapFunc: {
      type: Function,
      default: null,
    },
    backSearch: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    backLoad: {
      type: Boolean,
      default: true,
    },
    onInputFunc: {
      type: Function,
      default: null,
    },
    preloadFunc: {
      type: Function,
      default: null,
    },
    loadFunc: {
      type: [Function, null],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    showCode: {
      type: Boolean,
      default: false,
    },
    codeValue: {
      type: String,
      default: '',
    },
    groupBy: {
      type: String,
      default: '',
    },
    storageKey: {
      type: String,
      default: '',
    },
    compact: {
      type: Boolean,
      default: false,
    },
    toPortal: {
      type: Boolean,
      default: false,
    },
  },
  /* async fetch () {
    if (this.$parent?.$parent?.$el?.className === 'base-filter' && this.isCabinet) {
      await this.fill(this.value, this.backLoad ? 'initial' : 'update');
    }
  }, */
  data () {
    return {
      loading: false,
      isOpen: false,
      fuse: null,
      groupedItemsObject: {},
      allItems: [],
      filteredItems: [],
      items: [],
      selectedItems: [],
      selectedItem: null,
      sender: getCargoSender(),
      term: '',
      typeAheadPointer: -1,
      randomId: null,
      initialLoadPromise: null,
      isFocused: false,
      limit: 50,
      page: 1,
      debouncedSearch: debounce(this.search, 300),
      delayedFocusout: debounce(this.focusout, 200),
      searchRequestId: 0,
    };
  },
  computed: {
    rootId () {
      return this.id || null;
    },
    inputId () {
      return this.id ? `${this.id}-input` : `${this.randomId}-input`;
    },
    secondaryInputId () {
      return this.id ? `${this.id}-input-secondary` : `${this.randomId}-input-secondary`;
    },
    isFilled () {
      return !!(this.term ||
        typeof this.term === 'number' ||
        this.selectedItems.length ||
        this.selectedItem);
    },
    isSelected () {
      return !!((this.multiple && this.selectedItems && this.selectedItems.length) ||
        (!this.multiple && this.selectedItem));
    },
    selectedItemsValues () {
      if (!this.selectedItems) return [];
      return this.selectedItems.map(item => item[this.idProperty]);
    },
    lastOptionIndex () {
      return this.items.length - 1;
    },
    reversedOptions () {
      return [...this.items].reverse();
    },
    keysWeights () {
      const result = {};
      this.searchKeys.forEach(key => {
        result[key.name] = key.weight;
      });
      return result;
    },
    classes () {
      return {
        'base-autocomplete--focused': this.isFocused,
        'base-autocomplete--filled': this.isFilled,
        'base-autocomplete--error': this.isError,
        'base-autocomplete--disabled': this.disabled,
        'base-autocomplete--big': this.big,
        'base-autocomplete--long': this.long,
        'base-autocomplete--multiple': this.multiple,
        'base-autocomplete--grouped': !!this.groupBy,
        'base-autocomplete--compact': this.compact,
        'base-autocomplete--static-label': this.placeholder,
        'base-autocomplete--placeholder-only': this.placeholder && !this.label,
      };
    },
    fuseOptions () {
      return {
        isCaseSensitive: false,
        includeScore: true,
        includeMatches: false,
        ignoreLocation: true,
        shouldSort: this.shouldSortSearch,
        threshold: 0.2,
        minMatchCharLength: 1,
        keys: this.searchKeys,
      };
    },
    isInsideOfCabinetFilter () {
      return this.$parent?.$parent?.$el?.className === 'base-filter' && this.isCabinet;
    },
  },
  watch: {
    value: {
      handler (value) {
        if (!this.inputAsIs) this.fill(value);
        else if (!value) this.clean();

        if (this.inputAsIs) this.term = this.value;
      },
      deep: true,
    },
  },
  created () {
    this.debouncedSearch = debounce(this.search, 300);
    this.delayedFocusout = debounce(this.focusout, 200);

    this.loading = true;
    if (!this.backLoad) this.allItems = this.options;
  },
  async mounted () {
    this.randomId = String(Math.random());

    await this.init();
    // if (this.isInsideOfCabinetFilter) {
    //   await this.fill(this.value, this.backLoad ? 'initial' : 'update');
    // } else {
    // }

    if (!this.backSearch && this.$refs.list) {
      this.$refs.list.$el.addEventListener('scroll', () => {
        this.onScroll();
      });
    }
  },
  beforeDestroy () {
    if (!this.backSearch && this.$refs.list) {
      this.$refs.list.$el.removeEventListener('scroll', () => {});
    }
  },
  methods: {
    async init (withFill = true) {
      if (this.preloadFunc) {
        await this.preloadFunc();
      }

      if (withFill) await this.fill(this.value, this.backLoad ? 'initial' : 'update');

      if (this.backLoad) {
        this.initialLoadPromise = this.loadData();
        try {
          this.allItems = await this.initialLoadPromise || [];
        } finally {
          this.initialLoadPromise = null;
        }
      }

      this.loading = false;
      this.$emit('loaded');

      if (!this.backSearch) {
        const indexes = Fuse.createIndex(this.fuseOptions.keys, this.allItems);
        this.fuse = new Fuse(this.allItems, this.fuseOptions, indexes);
      }

      // await this.fill(this.value, 'update');

      this.search();
    },
    frontSearch (value = '') {
      const trimmedValue = value ? String(value).trim() : value;
      this.fuseSearch(trimmedValue);
      this.loading = false;
      if (!this.items || !this.items.length) {
        if (this.onInputFunc) this.onInputFunc(trimmedValue, this);
        else if (trimmedValue && trimmedValue.length) this.searchTranslit(trimmedValue);
      }
    },
    searchTranslit (value) {
      const translitValue = convertToTranslit(value);
      this.fuseSearch(translitValue);
    },
    fuseSearch (value) {
      if (this.$refs.list) this.$refs.list.$el.scrollTop = 0;
      this.page = 1;
      this.filteredItems = value !== '' && this.fuse
        ? this.fuse.search(value, { limit: this.limit * 2 }).map(v => v.item)
        : this.allItems;

      this.items = this.filteredItems?.slice(0, this.limit);
    },
    async backendSearch (value = '') {
      const requestId = ++this.searchRequestId;
      this.loading = true;

      try {
        const response = await this.loadData(value);

        if (requestId !== this.searchRequestId) return;

        this.allItems = response;
        this.items = response;
        this.page = 1;

        if ((!response || !response.length) && this.onInputFunc) {
          this.onInputFunc(value, this);
        }
      } finally {
        this.loading = false;
      }
    },
    search (value = '') {
      if (!this.backSearch) this.frontSearch(value);
      else this.backendSearch(value);
    },
    loadData (term = '', type = 'term') {
      if (this.loadFunc) {
        return this.loadFunc(term, type)
          .then(response => this.handleDataResponse(response));
      }

      const isTerm = type === 'term';
      const body = isTerm
        ? {
          ...this.params,
          term,
          ...this.backSearch && { limit: this.limit },
        }
        : {
          ...this.valuesParams,
          values: term,
          ...this.backSearch && { limit: 100 },
        };

      return autocompleteManager
        .get(
          this.storageKey || this.path,
          this.idProperty,
          this.labelProperty,
          body
        )
        .then(response => this.handleDataResponse(response))
        // eslint-disable-next-line no-console
        .catch(err => console.error(err));
    },
    handleDataResponse (response) {
      const { data } = response;
      const formattedData = this.formatData(data);
      return Promise.resolve(this.filterFunc
        ? formattedData.filter(item => this.filterFunc(item))
        : formattedData
      );
    },
    formatData (data) {
      let tempData = data;

      if (this.groupBy) {
        tempData = this.getGroupedList(data);
      }

      if (this.isFlat) {
        return tempData.map(item => {
          return {
            [this.labelProperty]: item || this.$t('base.noName'),
            [this.idProperty]: item || '<<<none>>>',
          };
        });
      }

      return this.mapFunc
        ? tempData.map(item => this.mapFunc(item))
        : tempData;
    },
    async fill (value, type = 'update') {
      if (this.multiple) {
        await this.fillMultiple(value, type);
        const newValues = this.selectedItems.map(item => item[this.idProperty]);
        if (value && value.length !== newValues.length) this.change(newValues);
      } else {
        await this.fillOne(value, type);
        const newValue = this.selectedItem ? this.selectedItem[this.idProperty] : null;
        if (value !== newValue && ((this.inputAsIs && type !== 'initial') || !this.inputAsIs)) {
          this.change(newValue);
        }
        this.changeFull(this.selectedItem);
      }
    },
    async fillMultiple (value, type) {
      if (value && value.length) await this.fillSelectedItems(value, type);
      else if (type === 'update') this.clean();
    },
    async fillOne (value, type) {
      if (value) await this.fillSelectedItem(value, type);
      else if (type === 'update') this.clean();
    },
    async fillSelectedItems (value, type) {
      const difference = value.filter(x => !this.selectedItemsValues.includes(x));
      if (difference.length) {
        const notNullValues = await this.findMultiple(difference, type).then(values => {
          return values.filter(v => v && !v.group);
        });
        this.selectedItems.push(...notNullValues);
      }
    },
    waitForLoadData () {
      return this.initialLoadPromise || Promise.resolve();
    },
    async fillSelectedItem (value, type) {
      if (this.inputAsIs) this.term = value;
      else if (!this.selectedItem || value !== this.selectedItem[this.idProperty]) {
        if ((!this.allItems || !this.allItems.length) && this.backLoad && this.loading) {
          await this.waitForLoadData();
        }
        const res = await this.findOne(value, type);
        this.selectedItem = res || null;
        if (this.selectedItem) this.term = this.selectedItem[this.labelProperty];
      }
    },
    async findMultiple (values, type = 'update') {
      if (type === 'initial') {
        return this.loadData(values.map(v => v === '<<<none>>>' ? '' : v), 'values').then(res => {
          if (this.isInsideOfCabinetFilter) {
            this.$parent?.$parent?.mounted();
          }
          return Promise.resolve(res && res.length > 0 ? res : []);
        });
      }
      const promises = [];
      values.forEach(item => {
        promises.push(this.findOne(item, type));
      });
      return await Promise.all(promises);
    },
    async findOne (value, type = 'update') {
      if (type === 'initial') {
        return this.loadData([value], 'values').then(res => {
          if (this.isInsideOfCabinetFilter) {
            this.$parent?.$parent?.mounted();
          }
          return Promise.resolve(res && res.length > 0 ? res[0] : null);
        });
      }

      const res = await this.allItems.find(item => {
        return item[this.idProperty] === value && !item[this.disabledProperty];
      });

      return res;
    },
    isFirstMatch () {
      if (!this.items || !this.items.length || !this.term) return false;
      return Object.keys(this.items[0])
        .filter(key => this.keysWeights[key] && this.keysWeights[key] > 0.1)
        .some(key => String(this.items[0][key]).toLowerCase() === String(this.term).toLowerCase());
    },
    fillInput (val) {
      this.isFocused = true;
      this.isOpen = true;
      this.term = val;
      this.typeAheadPointer = -1;
      this.debouncedSearch(val);
      if (val && this.inputAsIs) {
        this.change(val);
      } else if (!this.multiple) {
        this.change(null);
        this.changeFull(null);
      }
    },
    selectItem (item) {
      if (item[this.disabledProperty]) return;
      if (item.group && this.multiple) return this.selectGroupItems(item);

      if (this.multiple) {
        const hasSearchTerm = Boolean(this.term.trim());
        const value = this.value || [];
        this.term = '';
        this.selectedItems.push(item);
        this.change([...value, item[this.idProperty]]);

        if (hasSearchTerm) this.search();
      } else {
        this.term = item[this.labelProperty];
        this.$set(this, 'selectedItem', item);
        this.change(item[this.idProperty]);
        this.changeFull(item);
        if (this.$refs.mainInput) this.$refs.mainInput.$refs[this.inputId].blur();
        this.hideDropdown();
        setTimeout(() => this.search(), 500); // TODO: remove search
      }
    },
    selectGroupItems (groupItem) {
      const groupName = groupItem[this.labelProperty];
      const groupItems = this.groupedItemsObject[groupName];
      groupItems.forEach(item => {
        if (this.isPickedOption(item[this.idProperty])) return;
        this.selectItem(item);
      });
    },
    enter () {
      if (this.typeAheadPointer === -1) this.typeAheadDown();
      this.typeAheadSelect();
    },
    onScroll () {
      const el = this.$refs.list.$el;
      const start = this.page * this.limit;
      const end = (this.page + 1) * this.limit;

      if (
        (el.scrollTop + el.clientHeight >= el.scrollHeight) &&
        this.filteredItems.length > start
      ) {
        this.items.push(...this.filteredItems.slice(start, end));
        this.page += 1;
      }
    },
    clickaway () {
      if (!this.isMobile) this.hideDropdown();
    },
    hideDropdown () {
      this.isOpen = false;
    },
    focusin () {
      /* if (this.isMobile) {
        setTimeout(() => {
          window.scrollTo({ top: this.$el.offsetTop - 70 });
        }, 100);
      } */
      this.$emit('focusin');
    },
    inputFocus () {
      this.isFocused = true;
    },
    manualFocus () {
      this.isOpen = true;
      if (!this.isMobile) this.$refs.mainInput.$refs[this.inputId].focus();
    },
    focusout () {
      // OS keyboard-layout switchers can emit a transient focusout while the input stays active.
      if (!document.hasFocus() || this.$refs.container?.contains(document.activeElement)) return;

      if (!this.inputAsIs && !this.isSelected) this.selectFirstMatched();
      this.isFocused = false;
      if (this.multiple) return;
      if (!this.isMobile) this.hideDropdown();
      this.$emit('focusout');
    },
    selectFirstMatched () {
      if (this.isFirstMatch()) {
        this.selectItem(this.items[0]);
      }
    },
    typeAheadUp () {
      if (!this.disabled) {
        if (!this.isOpen) {
          this.isOpen = true;
        }
        if (this.typeAheadPointer > 0) {
          const nextPointer = this.typeAheadPointer - 1;
          const option = this.items[nextPointer];
          const isDisabled = option ? option[this.disabledProp] || false : false;
          if (!isDisabled) {
            this.typeAheadPointer -= 1;
          } else {
            this.typeAheadPointer -= 1;
            this.typeAheadUp();
          }
        } else {
          const nextEnabledOption = this.reversedOptions.findIndex(
            o => o[this.disabledProp] !== true
          );
          this.typeAheadPointer = this.lastOptionIndex - nextEnabledOption;
        }
      }
    },
    typeAheadDown () {
      if (!this.disabled) {
        if (!this.isOpen) {
          this.isOpen = true;
        }
        if (this.typeAheadPointer < this.lastOptionIndex) {
          const nextPointer = this.typeAheadPointer + 1;
          const option = this.items[nextPointer];
          const isDisabled = option ? option[this.disabledProp] || false : false;
          if (!isDisabled) {
            this.typeAheadPointer += 1;
          } else {
            this.typeAheadPointer += 1;
            this.typeAheadDown();
          }
        } else {
          this.typeAheadPointer = this.items.findIndex(
            o => o[this.disabledProp] !== true
          );
        }
      }
    },
    typeAheadSelect () {
      if (
        this.items[this.typeAheadPointer] &&
        !this.isPickedOption(this.items[this.typeAheadPointer][this.idProperty])
      ) {
        this.selectItem(this.items[this.typeAheadPointer]);
      }
      this.$emit('enter');
    },
    isSelectedOption (option, index) {
      return this.typeAheadPointer === index;
    },
    isPickedOption (id) {
      if (this.multiple) return this.selectedItems.map(item => item[this.idProperty]).includes(id);
      return this.selectedItem && this.selectedItem[this.idProperty] === id;
    },
    removeItem (index) {
      this.selectedItems.splice(index, 1);
      const selected = [...this.selectedItems];
      this.change(selected.map(item => item[this.idProperty]));
    },
    unselectItem (item) {
      // eslint-disable-next-line vue/max-len
      const index = this.selectedItems.findIndex(i => i[this.idProperty] === item[this.idProperty]);
      this.selectedItems.splice(index, 1);
      const selected = [...this.selectedItems];
      this.change(selected.map(item => item[this.idProperty]));
    },
    change (value) {
      this.$emit('change', value);
    },
    changeFull (value) {
      this.$emit('change-full', value);
    },
    clean () {
      if (this.isOpen) setTimeout(() => this.isOpen = true, 300);
      if (this.multiple) this.cleanMultiple();
      else this.cleanOne();

      this.change(null);
      this.changeFull(null);

      this.term = '';
      if (typeof this.debouncedSearch === 'function') this.debouncedSearch();
    },
    cleanMultiple () {
      this.$set(this, 'selectedItems', []);
      this.typeAheadPointer = -1;
    },
    cleanOne () {
      this.selectedItem = null;
      this.typeAheadPointer = -1;
    },
    getGroupedList (items = []) {
      this.groupedItemsObject = this.getGroupedObject(items, this.groupBy);
      const groupsNames = Object.keys(this.groupedItemsObject);

      return groupsNames.reduce((groupedList, groupName) => {
        const groupItem = {
          [this.labelProperty]: groupName,
          group: true,
        };

        if (groupName !== '') {
          groupedList.push(this.mapFunc ? this.mapFunc(groupItem) : groupItem);
        }

        const groupItems = this.groupedItemsObject[groupName];

        groupedList.push(...groupItems.map(item => {
          if (groupName !== '') return item;
          item.withoutGroup = true;
          return item;
        }));

        return groupedList;
      }, []);
    },
    getGroupedObject (items = [], groupProperty = 'group') {
      return items.reduce((itemsByGroup, item) => {
        const groupName = item[groupProperty] || '';

        if (!itemsByGroup[groupName]) itemsByGroup[groupName] = [];
        itemsByGroup[groupName].push(item);

        return itemsByGroup;
      }, {});
    },
  },
};
